const TRUTHS = [
  {
    num: 1,
    title: "YOU ENTER WITHOUT A DEFINED REASON",
    problem: "Reacting to movement without clear logic. Random entries = random results.",
    truth: "Clarity beats chaos. Define ONE reason before entering. No reason = no trade.",
    action: "Define your reason before every single trade entry.",
    image: "/slide_02.png"
  },
  {
    num: 2,
    title: "YOU CONFUSE ACTIVITY WITH PROGRESS",
    problem: "More trades, more charts... but no improvement. Being busy is not the same as getting better.",
    truth: "Measure outcomes, not hours.",
    action: "Track your results, not your effort. Measure outcomes.",
    image: "/slide_03.png"
  },
  {
    num: 3,
    title: "YOU RELY ON MEMORY INSTEAD OF DATA",
    problem: "Your memory is biased. Feelings distort your recall of past trades.",
    truth: "Numbers don't lie. Journal your trades with data, not feelings.",
    action: "Open a journal tool. Record every trade with hard data.",
    image: "/slide_04.png"
  },
  {
    num: 4,
    title: "YOU DON'T KNOW YOUR EDGE",
    problem: "Reacting without understanding. Copying trades is not having an edge.",
    truth: "Your edge is your specific, repeatable reason for consistent winning.",
    action: "Define your edge — your specific, repeatable reason to win.",
    image: "/slide_05.png"
  },
  {
    num: 5,
    title: "YOU ENTER BASED ON EMOTION",
    problem: "Reacting to Fear, Excitement, or Impatience.",
    truth: "Replace Feelings with Logic. Wait for confirmation.",
    action: "Wait for confirmation. Never enter on impulse.",
    image: "/slide_06.png"
  },
  {
    num: 6,
    title: "YOU DON'T HAVE A REPEATABLE PROCESS",
    problem: "Random entries = Random results. Without structure, every trade feels different.",
    truth: "Repeatable process leads to predictable, reliable results.",
    action: "Build a simple flow: Analysis → Setup → Execution.",
    image: "/slide_07.png"
  },
  {
    num: 7,
    title: "YOU FOCUS TOO MUCH ON ENTRY",
    problem: "Obsessing over the perfect entry, ignoring trade management and continuation.",
    truth: "An effective exit plan is vital. Plan exit before entry. Define TP & SL.",
    action: "Plan your exit before entry. Define TP & SL first.",
    image: "/slide_08.png"
  },
  {
    num: 8,
    title: "YOU OVERCOMPLICATE YOUR SETUP",
    problem: "Too many indicators. Chaos and confusion. No clear entry signal.",
    truth: "Less is more. Simplify your setup. Remove clutter for clarity.",
    action: "Simplify your setup. Strip it down to one core signal.",
    image: "/slide_09.png"
  },
  {
    num: 9,
    title: "YOU DON'T TRUST YOUR OWN DECISIONS",
    problem: "Lack of conviction. Hesitation leads to missed opportunities and regret.",
    truth: "Clarity builds confidence. Trust comes from a defined trading system.",
    action: "Define your system so you can trust and execute with conviction.",
    image: "/slide_10.png"
  },
  {
    num: 10,
    title: "YOU REACT INSTEAD OF PLAN",
    problem: "Wait for movement... then chase it. Late decisions lead to bad trades.",
    truth: "Plan first, execute second. Define your plan before the market moves.",
    action: "Define your plan before the market opens. Execute, don't react.",
    image: "/slide_11.png"
  },
  {
    num: 11,
    title: "YOU DON'T LEARN FROM LOSSES",
    problem: "Unreviewed losses lead to repeating the same mistakes over and over.",
    truth: "Progress is built on self-reflection. Review every trade.",
    action: "Review every trade. Start journaling your errors today.",
    image: "/slide_12.png"
  },
  {
    num: 12,
    title: "YOU TRADE WITHOUT CONTEXT",
    problem: "Looking only at one timeframe, missing the bigger picture entirely.",
    truth: "Multi-timeframe analysis reveals the true market structure. Zoom out.",
    action: "Zoom out. Always check higher timeframes before entry.",
    image: "/slide_13.png"
  },
  {
    num: 13,
    title: "YOU LET ONE TRADE CONTROL YOU",
    problem: "The emotional rollercoaster: fear, anger, overconfidence, ego after each trade.",
    truth: "Break the emotional link between trades. Treat every trade as independent.",
    action: "Mandatory mental reset after every trade. Step away, then return neutral.",
    image: "/slide_14.png"
  },
  {
    num: 14,
    title: "YOU DON'T HAVE CLEAR RULES",
    problem: "Trading without defined rules leads to uncertainty and poor decisions.",
    truth: "Define strict entry criteria. Pre-set stop loss. Risk max 1-2% per trade.",
    action: "Write your rules down. Entry criteria, stop loss, max risk per trade.",
    image: "/slide_15.png"
  },
  {
    num: 15,
    title: "YOU CHASE THE MARKET",
    problem: "Chasing late momentum, entering after the ideal signal has passed.",
    truth: "The best entries are found in patience. Focus on the pull, not the push.",
    action: "Wait for pullbacks. Never chase a candle.",
    image: "/slide_16.png"
  },
  {
    num: 16,
    title: "YOU IGNORE RISK MANAGEMENT",
    problem: "Focusing solely on profits without adequate risk management consideration.",
    truth: "Prioritize risk control and capital preservation for long-term stable growth.",
    action: "Risk small. Always. Protect your capital above everything.",
    image: "/slide_17.png"
  },
  {
    num: 17,
    title: "YOU EXPECT FAST RESULTS",
    problem: "Wanting quick wins leads to impulsive, unrewarded moves.",
    truth: "Long-term compounding is the true goal. Patience is rewarded.",
    action: "Cultivate discipline & consistency. Trading is a long-term game.",
    image: "/slide_18.png"
  },
  {
    num: 18,
    title: "YOU KEEP SWITCHING STRATEGIES",
    problem: "Constantly changing strategies prevents mastering any single approach.",
    truth: "Master one system and continuously improve it. Depth over breadth.",
    action: "Stick to one system. Continuously improve it. Depth beats breadth.",
    image: "/slide_19.png"
  },
  {
    num: 19,
    title: "YOU'RE NOT HONEST WITH YOURSELF",
    problem: "Blaming external factors instead of examining your own decision-making.",
    truth: "True mastery comes from taking full responsibility for your results.",
    action: "Take full responsibility. Journal rigorously. Critique every trade.",
    image: "/slide_20.png"
  },
  {
    num: 20,
    title: "YOU TRADE WITHOUT STRUCTURE",
    problem: "Everything feels random. Lack of system leads to inconsistency.",
    truth: "Structure is the framework for predictable results and repeatability.",
    action: "Define your system. Build structure for every trading session.",
    image: "/slide_21.png"
  },
  {
    num: 21,
    title: "YOU DON'T PREPARE",
    problem: "Trading impulsively, reacting to price moves without checking conditions.",
    truth: "Preparation before the market opens is the difference between success and ruin.",
    action: "Establish a repeatable pre-market routine. Analyze before the bell.",
    image: "/slide_22.png"
  },
  {
    num: 22,
    title: "YOU LET NOISE CONTROL YOU",
    problem: "Signal overload kills clarity. Too many sources, too many opinions.",
    truth: "Define ONE key information source. Filter the noise ruthlessly.",
    action: "Cut the noise. Define ONE trusted information source.",
    image: "/slide_23.png"
  },
  {
    num: 23,
    title: "YOU DON'T KNOW WHEN TO STOP",
    problem: "Forcing trades on weak setups, seeing entries that aren't there.",
    truth: "The best trade is often no trade. Patience is discipline.",
    action: "Skip bad setups. The best trade is sometimes no trade.",
    image: "/slide_24.png"
  },
  {
    num: 24,
    title: "YOU TRADE WITHOUT CONFIDENCE",
    problem: "Hesitation before entering due to lack of clarity in your system.",
    truth: "Clarity builds confidence. Define your system, trust your process.",
    action: "Simplify your process. Clarity creates confidence.",
    image: "/slide_25.png"
  },
  {
    num: 25,
    title: "YOU DON'T HAVE CLEAR DIRECTION",
    problem: "Reacting to noise without a defined market bias leads to random decisions.",
    truth: "Know your directional bias and act with conviction.",
    action: "Define your bias before every session. Act with conviction.",
    image: "/slide_26.png"
  },
  {
    num: 26,
    title: "YOU REPEAT THE SAME MISTAKES",
    problem: "Recursive error cycle: repeating mistakes without review means no progress.",
    truth: "Track, Review, Improve. Break the cycle with a thorough review process.",
    action: "Track every trade. Review for patterns. Implement changes.",
    image: "/slide_27.png"
  },
  {
    num: 27,
    title: "YOU'RE TRADING WITHOUT A SYSTEM",
    problem: "Relying on instinct leads to inconsistency in trading results.",
    truth: "A defined, rule-based trading system beats raw instinct every time.",
    action: "Build your trading system. A rule-based system is the path to profit.",
    image: "/slide_28.png"
  }
];

export default TRUTHS;
